module.exports = __webpack_public_path__ + "media/images/smart_phone/toplogo_06-eaab979a22a571623c31cf3c873bead1.png";